import video from './video';

function declOfNum(num, words) {
	let cases = [2, 0, 1, 1, 1, 2];

	return words[num % 100 > 4 && num % 100 < 20 ? 2 : cases[num % 10 < 5 ? num % 10 : 5]];
}

export function initTimer(startTime, currentPage) {
	let $timer = currentPage.find('.timer');
	let $days = $timer.find('.timer__days');
	let $hours = $timer.find('.timer__hours');
	let $minutes = $timer.find('.timer__minutes');

	let intervalId = 0;

	let getTime = () => {
		let currentTime = Date.parse(new Date());
		let diffTime = startTime - currentTime;

		if (diffTime < 1) {
			clearInterval(intervalId);

			video.initVideo(currentPage);

			return;
		}

		let minutes = Math.floor(diffTime / 1000 / 60 % 60);
		let hours = Math.floor(diffTime / (1000 * 60 * 60) % 24);
		let days = Math.floor(diffTime / (1000 * 60 * 60 * 24));

		$days
			.text(days)
			.next('.timer__text').text(declOfNum(days, ['день', 'дня', 'дней']));
		$hours
			.text(hours)
			.next('.timer__text').text(declOfNum(hours, ['час', 'часa', 'часов']));
		$minutes
			.text(minutes)
			.next('.timer__text').text(declOfNum(minutes, ['минута', 'минуты', 'минут']));
	};

	intervalId = setInterval(getTime, 60000);

	getTime();
}
